import { useState } from 'react';
import { validateCampaignApplication, fetchCampaignApplicationCompletionStatus } from '~/services/campaign';
import {
    ApplicationCompletionStatus,
} from '~/types/application-completion';
import { toast } from 'react-hot-toast';

interface Props {
    application?: any;
    completionStatus?: ApplicationCompletionStatus | null;
}

const ApplicationStatusTab: React.FC<Props> = ({
    application,
    completionStatus: propCompletionStatus,
}) => {
    const [validating, setValidating] = useState(false);
    
    // Always use the completion status from props (fetched by parent)
    const completionStatus = propCompletionStatus;
    const loading = !completionStatus;

    const handleValidate = async () => {
        if (!application?.campaign) {
            toast.error('No campaign found');
            return;
        }

        try {
            setValidating(true);

            // Call the validate endpoint to persist the ApplicationCompleted record
            const validateResponse = await validateCampaignApplication(
                application.campaign
            );

            if (validateResponse.updated) {
                toast.success('Application validated and saved successfully');
            } else {
                toast.success('Application validation complete');
            }
        } catch (error) {
            toast.error('Failed to validate application');
        } finally {
            setValidating(false);
        }
    };

    if (loading) {
        return (
            <div className='mb-7.5 flex items-center justify-center py-8'>
                <div className='text-gray-500'>
                    Loading application status...
                </div>
            </div>
        );
    }

    if (!completionStatus) {
        return (
            <div className='mb-7.5 flex items-center justify-center py-8'>
                <div className='text-gray-500'>
                    No application status available
                </div>
            </div>
        );
    }

    return (
        <div className='mb-7.5'>
            <div className='flex items-center justify-between'>
                <h2 className='text-[22px]/[28px] font-bold'>
                    Application Summary
                </h2>

                <div className='flex gap-2'>
                    {!completionStatus.has_completion_record && (
                        <button
                            onClick={handleValidate}
                            className='rounded-full border-[2px] px-[24px] py-[7px] text-[14px]/[18px] font-bold uppercase transition-colors duration-500 hover:border-black hover:bg-black hover:text-white disabled:cursor-not-allowed disabled:opacity-50'
                            disabled={loading || validating}
                        >
                            {validating ? 'Validating...' : 'Validate'}
                        </button>
                    )}
                </div>
            </div>

            {(application?.application_completed_at || application?.completion?.application_completed_at) && (
                <div className='mt-2 text-sm text-gray-600'>
                    Completed: {new Date(
                        application?.application_completed_at || application?.completion?.application_completed_at
                    ).toLocaleDateString('en-US', {
                        year: 'numeric',
                        month: 'long',
                        day: 'numeric',
                        hour: '2-digit',
                        minute: '2-digit'
                    })}
                </div>
            )}
        </div>
    );
};

export default ApplicationStatusTab;
